import TrainingSessionLesson from '../session-lesson';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSessionLesson.update((data, fetch) => {
    // Prepare request
    let formData = new FormData();
    formData.append('_method', 'PUT');
    ['title', 'description', 'order_index', 'evidence_required']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/trainings/${data.trainingId}/sessions/${data.sessionId}/lessons/${data.lessonId}`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
